module.exports = "/images/vendor/flag-icon-css/flags/1x1/tl.svg?0616faaafebb8abad85242c3b67f7ec5";